import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth, USER_ROLES } from '../../context/AuthContext';
import './BottomNavigation.css';

const BottomNavigation = () => {
  const { currentUser, userRole } = useAuth();
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  if (!currentUser) return null;

  return (
    <nav className="bottom-navigation">
      {userRole === USER_ROLES.MENTOR ? (
        <>
          <Link 
            to="/profile" 
            className={`bottom-nav-item ${isActive('/profile') ? 'active' : ''}`}
          >
            <i className="fas fa-user"></i>
            <span className="bottom-nav-label">プロフィール</span>
          </Link>
          <Link 
            to="/mentors-list" 
            className={`bottom-nav-item ${isActive('/mentors-list') ? 'active' : ''}`}
          >
            <svg className="bottom-nav-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/>
            </svg>
            <span className="bottom-nav-label">OG一覧</span>
          </Link>
          <Link 
            to="/invite-mentor" 
            className={`bottom-nav-item ${isActive('/invite-mentor') ? 'active' : ''}`}
          >
            <svg className="bottom-nav-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
            </svg>
            <span className="bottom-nav-label">OG招待</span>
          </Link>
        </>
      ) : userRole === USER_ROLES.STUDENT ? (
        <>
          <Link 
            to="/student-profile" 
            className={`bottom-nav-item ${isActive('/student-profile') ? 'active' : ''}`}
          >
            <i className="fas fa-user"></i>
            <span className="bottom-nav-label">プロフィール</span>
          </Link>
          <Link 
            to="/mentors-list" 
            className={`bottom-nav-item ${isActive('/mentors-list') ? 'active' : ''}`}
          >
            <svg className="bottom-nav-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/>
            </svg>
            <span className="bottom-nav-label">OG一覧</span>
          </Link>
        </>
      ) : (
        // ADMIN またはその他の役割の場合
        <>
          <Link 
            to="/mentors-list" 
            className={`bottom-nav-item ${isActive('/mentors-list') ? 'active' : ''}`}
          >
            <svg className="bottom-nav-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/>
            </svg>
            <span className="bottom-nav-label">OG一覧</span>
          </Link>
          {userRole === USER_ROLES.ADMIN && (
            <Link 
              to="/admin" 
              className={`bottom-nav-item ${isActive('/admin') ? 'active' : ''}`}
            >
              <svg className="bottom-nav-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
              </svg>
              <span className="bottom-nav-label">管理者画面</span>
            </Link>
          )}
        </>
      )}
    </nav>
  );
};

export default BottomNavigation; 